import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCHhTK85QsreEsrvGrq1fMQn_qw5J2Z3Ks",
  authDomain: "caledonian-5437b.firebaseapp.com",
  projectId: "caledonian-5437b",
  storageBucket: "caledonian-5437b.firebasestorage.app",
  messagingSenderId: "1091025656795",
  appId: "1:1091025656795:web:8b293c7789bada4492e5fe"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export const requestFirebaseNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      const token = await getToken(messaging, {
        vapidKey: 'BPwtbmPruloFJsknZPFY8eGnDuIfYyNTrj3z_qsWshEIDhOeLYUJjRlY2rH3vjn-ZfcoLZ9x-xwQlHlmsuXv10I'
      });
      console.log('FCM Token:', token);
      return token;
    } else {
      console.warn('Notification permission not granted.');
      return null;
    }
  } catch (error) {
    console.error('Error getting FCM token:', error);
    return null;
  }
};

onMessage(messaging, (payload) => {
  console.log('Message received in foreground:', payload);
});
